var map = {
	"./de/game.json": [
		"dc7e",
		"chunk-2d2290c3"
	],
	"./en/game.json": [
		"bc67"
	],
	"./fr/game.json": [
		"d44a",
		"chunk-2d21dff3"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "ca3f";
module.exports = webpackAsyncContext;